import { LifeglovUsage } from '@bioliberty/lifemind';
import { InternalTabsList } from '../components/InternalTabsList';
import { LatestLifeglovUsageTile } from '../components/LatestLifeglovUsageTile';

export interface LifeglovsTabProps {
  latestLifeglovUsage: Record<string, LifeglovUsage>;
}

export function LifeglovsTab({ latestLifeglovUsage }: LifeglovsTabProps) {
  return (
    <div className="flex flex-col gap-4">
      <InternalTabsList />
      <LatestLifeglovUsageTile latestLifeglovUsage={latestLifeglovUsage} />
    </div>
  );
}
